import { ArticleItem } from "../types";
import classNames from "classnames";
import Image from "next/image";
import { ListingItemProps } from "./types";
import NextLink from "next/link";
import { PRODUCT_ARTICLE_IMAGE_WIDTH } from "./BookListingItem";
import { Typography } from "@cappelendamm/design-system/react";
import { getImageAspectRatio } from "@/cms/images/getImageAspectRatio";

export function ArticleListingItem({ item }: ListingItemProps<ArticleItem>) {
  const { imageUrl, name, slug } = item;

  return (
    <article
      className={classNames(
        "group row-span-(--list-row-count) grid grid-rows-subgrid gap-1",
        "overflow-hidden bg-(--cvr-canvas-background) outline-(--cvr-canvas-background) active:rounded active:outline-3 active:outline-offset-4",
      )}
    >
      <NextLink
        href={`/artikkel/${slug}`}
        aria-labelledby={`item-${slug}`}
        className={classNames(
          "relative row-span-full flex h-full flex-col no-underline",
        )}
      >
        <div className="grid items-start gap-4">
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt={`Portrettbilde av ${name}`}
              {...getImageAspectRatio({
                width: PRODUCT_ARTICLE_IMAGE_WIDTH,
                aspectRatio: "16/9",
              })}
              className="h-fit w-fit object-cover object-center transition-transform sm:group-hover:scale-102"
              quality={85}
            />
          ) : (
            <div className="aspect-square min-h-35 min-w-35 text-gray-200 transition-transform sm:group-hover:scale-102 sm:group-hover:text-gray-400" />
          )}
        </div>
        <span className="px-4 pt-4 text-sm">Artikkel</span>
        <Typography
          id={`item-${slug}`}
          as="h3"
          variant="title-md"
          className={classNames("flex grow p-4 sm:group-hover:underline")}
        >
          {name}
        </Typography>
      </NextLink>
    </article>
  );
}
